import type { Operator } from '@/data/operator';
import React, { useState } from 'react';

export default function NewOperatorForm({
  onAdd,
}: {
  onAdd: (op: Operator) => void;
}) {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newOp = {
      id: `op-${Date.now()}`,
      name,
      serialNumber: undefined, // completely useless
    };
    onAdd(newOp);
    setName('');
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col space-y-4 rounded-lg bg-gray-50 p-4 shadow-md"
    >
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
        className="rounded border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
      />
      <button
        type="submit"
        className="rounded bg-blue-500 px-4 py-2 text-sm font-medium text-white shadow-md hover:bg-blue-600 focus:ring-2 focus:ring-blue-400 focus:outline-none"
      >
        Add Operator
      </button>
    </form>
  );
}
